import { LINK_DASHBOARD_USERS } from 'swag-common/constants/dashboard-links.const';
const {
  BASE_URL
} = window.swag.env;
export const logout = `${BASE_URL}${LINK_DASHBOARD_USERS}`;